<template>
  <div v-if="visible" class="flex-center flex-col w-full h-[calc(100vh-59px)]">
    <Resource
      :src="getFeUrl('/youyan-platform/png/no-data.png')"
      :transform-resource="transformImage"
      class="h-[148px] mb-[10px]"
    />
    <a>{{ baseHref }}</a>
    <span class="text-font-80 mt-[10px]">{{ $t('lian-jie-yi-shi-xiao') }}</span>
  </div>
</template>
<script lang="ts" setup>
import { useConfirm } from '~/hooks/useModal/modals/confirm'
import { getUserToken, invitation, loginForWeb, lookCodeInfo } from '~/api'
import { BROADCAST_KEY, COOKIE_KEY } from '~/constants/config'

const route = useRoute()
const router = useRouter()
const homeRoute = useHomeRoute()
const { setSession } = useChangeUser()

const visible = ref(false)
const baseHref = window.location.href

const getData = async () => {
  const token = route.query.token as string
  const res = await lookCodeInfo({ token })

  return res.data
}

const init = async () => {
  const queryToken = route.query.token as string
  if (!queryToken) {
    router.replace(homeRoute)
    return
  }
  const { account_name, organization_name } = await getData()
  const { $t } = useNuxtApp()

  useConfirm({
    closable: false,
    title: $t('que-ding-jia-ru-organizationname-tuan-dui-ma', [
      organization_name,
    ]),
    cancelText: $t('ju-jue'),
    okText: $t('jia-ru'),
    onOk: async () => {
      const { code, msg, data } = await invitation(
        { token: queryToken },
        { autoErrorHandle: false }
      )
      if (code === 11008) {
        visible.value = true
        return
      }
      if (code === 0) {
        message.success($t('jia-ru-qi-ye-cheng-gong'))

        trackEvent(TRACK_EVENT.JOIN_TEAM, {
          team_id: data.organization_id,
          team_name: data.organization_name,
          members_id: data.user_id,
          members_name: data.username,
        })

        if (data?.user_id) {
          const token = await getUserToken(data.user_id)

          if (!token.code && token.data) {
            // session.value = token?.data?.[0]
            // if (session.value) {
            //   await loginForWeb(session.value)
            // }
            await setSession(token?.data?.[0])
            // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
            //   cookieValue: token?.data?.[0],
            // })
            emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID })
          }
        }
      } else {
        message.error(msg)
      }

      window.location.href = '/platform/'
    },
    onCancel: () => {
      router.replace(homeRoute)
    },
  })
}

init()
</script>
<style lang="scss" scoped></style>
